import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLanguage } from '@tabler/icons-react';
import styles from './LanguageSwitcher.module.scss';

interface Language {
  code: string;
  name: string;
  text: string;
}
// 2 languages for the switcher we can expand later
const languages: Language[] = [
  { code: 'de', name: 'Deutsch', text: 'DE' },
  { code: 'en', name: 'English', text: 'EN' },
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.languageSwitcher} ref={dropdownRef}>
      <button
        className={styles.currentLanguage}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={`Current language: ${currentLanguage.name}. Click to change language`}
        title={currentLanguage.name}
      >
        <IconLanguage size={16} stroke={1.8} className={styles.icon} />
        <span className={styles.flag}>{currentLanguage.text}</span>
      </button>
      
      {isOpen && (
        <div className={styles.dropdown}>
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => changeLanguage(language.code)}
              className={`${styles.languageOption} ${
                i18n.language === language.code ? styles.active : ''
              }`}
              title={language.name}
            >
              <span className={styles.flag}>{language.text}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
